import React from 'react';
import PropTypes from 'prop-types';
import JumpLink from './profile/JumpLink';

export const CautionFlagAdditionalInfo = ({
  cautionFlags,
  viewDetailsLink,
}) => {
  const validFlags = cautionFlags
    ? [...cautionFlags].filter(flag => flag.title)
    : [];

  const headline =
    validFlags.length === 1
      ? 'This school has 1 cautionary warning'
      : `This school has ${validFlags.length} cautionary warnings`;
  return (
    <div className="vads-u-border-left--10px vads-u-border-color--gold vads-u-background-color--white vads-u-padding-x--0p5">
      <div>
        <va-alert-expandable status="warning" trigger={headline}>
          <div className="va-alert-expandable-content">
            <ul>
              {validFlags
                .sort((a, b) =>
                  a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1,
                )
                .map((flag, index) => (
                  <li
                    className="headingFlag"
                    key={`caution-flag-heading-${index}`}
                  >
                    {flag.title}
                  </li>
                ))}
            </ul>
            {viewDetailsLink && (
              <JumpLink
                label="View details below"
                jumpToId="cautionary-information"
              />
            )}
          </div>
        </va-alert-expandable>
      </div>
    </div>
  );
};

CautionFlagAdditionalInfo.propTypes = {
  expanded: PropTypes.bool.isRequired,
  toggleExpansion: PropTypes.func.isRequired,
  cautionFlags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    }),
  ),
  viewDetailsLink: PropTypes.bool,
};

export default CautionFlagAdditionalInfo;
